<template>
  <div class="talent-level-container">
    <div class="list-wrap">
      <div class="clearfix">
        <router-link :to="{ name: 'setChannel',}">
          <span class="button is-info margin-left">新增频道</span>
        </router-link>
        <el-pagination
          @current-change="pageChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <table class="table is-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>频道名称</th>
                <th>频道介绍</th>
                <th>默认排序</th>
                <th>显示状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in list">
                <td>{{item.channelId}}</td>
                <td>{{item.name}}</td>
                <td>{{item.description}}</td>
                <td>
                  <input type="number" class="input" v-model="item.sort" @blur="doSaveSort(index)">
                </td>
                <td>{{item.status | getStatus}}</td>
                <td>
                  <router-link :to="{ name: 'setChannel', query:{channelId:item.channelId}}">
                    <a class="button is-primary">设置</a>
                  </router-link>
                  <router-link :to="{ name: 'articleList', query:{channelId:item.channelId}}">
                    <a class="button is-success">动态</a>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </article>
      </div>
      <div class="clearfix">
        <el-pagination
          @current-change="pageChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">

  export default {
    data(){
      return {
        list:[],
        count:0,
        search:{
          page:1,
          pageSize:10
        }
      }
    },
    created(){
      this.getList();
    },
    methods:{
      pageChange(page){
        if (this.search.page != page) {
          this.search.page = page
          this.getList()
        }
      },
      getList(){
        HttpRequest.get('/admin.php?method=main.getChannelList',this.search).then(response => {
          this.list = _.toArray(response.data.list);
          this.count = response.data.count;
        })
      },
      doSaveSort(index){
        let sort = this.list[index].sort.trim();
        if(!sort){
          this.$message("请输入一个排序号！");
          return false;
        }
        let params = {
          type : 2,
          sort : sort,
          targetId : this.list[index].channelId
        }
        HttpRequest.post('/admin.php?method=main.doSaveSort',params)
      }
    },
    filters:{
      getStatus(status){
        if(status == 0){
          return "隐藏";
        }else if(status == 1){
          return "显示";
        }else {
          return "";
        }
      }
    }
  }
</script>
<style lang="less" scoped>

</style>
